import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PL_ROUTING } from '@common/constant';
import {
  LicensedOrPurchaseGuard,
  UserNotAuthenticatedGuard,
} from 'pl-core-services';
import { PlRootComponent } from '@app/root/pl-root.component';
import { PlUserHasAccountGuard } from '@common/guards/pl-user-has-account-guard';
import { AuthCallbackComponent } from '@app/auth/auth-callback.component';
import { LoggedOutComponent } from '@app/auth/logged-out.component';
import { SiriusOrAuthGuard } from '@common/guards/sirius-or-auth.guard';
import { UseSiriusComponent } from '@app/auth/use-sirius.component';
import { PlSecureLayoutComponent } from './layout/pl-secure-layout/pl-secure-layout.component';
import { PurchaseGuard } from './purchase/guards';

const routes: Routes = [
  {
    path: 'use-sirius',
    component: UseSiriusComponent,
  },
  {
    path: 'auth',
    children: [
      {
        path: 'callback', // /auth/callback
        component: AuthCallbackComponent,
      },
      {
        path: 'logged-out', // /auth/logged-out
        component: LoggedOutComponent,
      },
    ],
  },
  {
    path: '',
    canActivate: [SiriusOrAuthGuard],
    data: { configId: 'kanga-local' }, // needed for Sirius, ignored by django auth
    children: [
      {
        path: PL_ROUTING.NO_ACCOUNT,
        loadChildren: () =>
          import('./no-account/no-account.module').then(
            (m) => m.NoAccountModule
          ),
      },
      // Access to user management is controlled by the data endpoint.
      // Users can have special access without having a license or account.
      {
        path: PL_ROUTING.USER_MANAGEMENT,
        component: PlSecureLayoutComponent,
        loadChildren: () =>
          import('./user-management/user-management.module').then(
            (m) => m.UserManagementModule
          ),
      },
      {
        path: '',
        canActivate: [PlUserHasAccountGuard],
        children: [
          {
            path: PL_ROUTING.PURCHASE,
            canActivateChild: [PurchaseGuard],
            component: PlSecureLayoutComponent,
            loadChildren: () =>
              import('./purchase/purchase.module').then(
                (m) => m.PurchaseModule
              ),
          },
          {
            path: '',
            component: PlSecureLayoutComponent,
            canActivate: [LicensedOrPurchaseGuard],
            children: [
              {
                path: '',
                component: PlRootComponent,
              },
              {
                path: PL_ROUTING.LANDING_HOME,
                loadChildren: () =>
                  import('./workspace/provider-workspace.module').then(
                    (m) => m.ProviderWorkspaceModule
                  ),
              },
              {
                path: PL_ROUTING.CLIENTS,
                loadChildren: () =>
                  import('./client/client.module').then((m) => m.ClientsModule),
              },
              {
                path: PL_ROUTING.CALENDAR,
                loadChildren: () =>
                  import('./calendar/calendar.module').then(
                    (m) => m.CalendarModule
                  ),
              },
              {
                path: PL_ROUTING.REPORTS,
                loadChildren: () =>
                  import('./reports/reports.module').then(
                    (m) => m.ReportsModule
                  ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: PL_ROUTING.REGISTRATION,
    canActivate: [UserNotAuthenticatedGuard],
    loadChildren: () =>
      import('./registration/registration.module').then(
        (m) => m.RegistrationModule
      ),
  },
  {
    path: PL_ROUTING.CONTACT_SALES,
    loadChildren: () =>
      import('./contact-sales/contact-sales.module').then(
        (m) => m.ContactSalesModule
      ),
  },
  {
    path: '**',
    loadChildren: () => import('./404/404.module').then((m) => m.Pl404Module),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
